
/* global isMobileDevice */ // defined in shared-main.tag
/* global dcAnalytics */

export function canUseApplePayOnThisDevice(isApplePayEnabled, isApplePayMobileOnly) {
    return window.ApplePaySession && isApplePayEnabled && (!isApplePayMobileOnly || isMobileDevice);
}

export function checkIsApplePayAvailable(isApplePayEnabled, isApplePayMobileOnly, stripePaymentRequest, applePayIsAvailableCallback) {
    if (!canUseApplePayOnThisDevice(isApplePayEnabled, isApplePayMobileOnly)) {
        return;
    }

    // This payment request is just used to determine if the Apple Pay button can be shown.
    // The one that is displayed is created when the button is clicked in the Apple Pay component.
    const paymentRequest = stripePaymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
            label: 'DonorsChoose',
            // Propose a fake charge of $1 just to see if Apple Pay is fully available (has a CC configured etc.).
            amount: 100,
        },
        requestPayerName: true,
        requestPayerEmail: true,
    });

    paymentRequest.canMakePayment().then(result => {
        if (result) {
            if (typeof applePayIsAvailableCallback === 'function') {
                applePayIsAvailableCallback();
            }
        }
    },
    function () {
        dcAnalytics.track('Apple Pay error', { errorType: 'Could not verify if user has active card' });
    });
}
